// extracted by mini-css-extract-plugin
module.exports =  {"resendButton":"resendButton___XzVpz"};